
interface AnalyticAccountCellDelegate
{
    addChildDidPress(cell:AnalyticAccountCell, account:AnalyticAccount):void;
    changeParentDidPress(cell:AnalyticAccountCell, account:AnalyticAccount):void;
}

class AnalyticAccountCell extends UITableViewCell
{
    delegate:AnalyticAccountCellDelegate|null = null;

    private titleTextField:MUITextField = null;
    private conceptTextField:MUITextField = null;
    private requiredLinkSwitch:MUISwitchButton = null;
    private ledgerAccountDropdown:MUIButton = null;
    private addChildButton:MUIButton = null;
    private changeParentButton:MUIButton = null;

    awakeFromHTML(){
        this.titleTextField = MUIOutlet(this, 'title-tf', 'MUITextField');
        this.titleTextField.setOnChangeText(this, function(this:AnalyticAccountCell, textfield:MUITextField, value:string){
            this._account.title = value.trim();
        });

        this.conceptTextField = MUIOutlet(this, 'concept-tf', 'MUITextField');
        this.conceptTextField.setOnChangeText(this, function(this:AnalyticAccountCell, textfield:MUITextField, value:string){
            let concept = value.trim();
            this._account.concept = concept.length > 0 ? concept : null;
        });

        this.requiredLinkSwitch = MUIOutlet(this, 'required-link-sb', 'MUISwitchButton');
        this.requiredLinkSwitch.setOnChangeValue(this, function(this:AnalyticAccountCell, control:MUISwitchButton, value:boolean){
            this._account.requiredLink = value;
        });

        this.ledgerAccountDropdown = MUIOutlet(this, 'ledger-account-dd', 'MUIButton');
        if (this.ledgerAccountDropdown) this.ledgerAccountDropdown.setAction(this, function(this:AnalyticAccountCell){
            AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.ledgerAccountDropdown, this._account.ledgerAccount, null, false, null, this, function(this:AnalyticAccountCell, controller:any, account:LedgerAccount){
                this._account.ledgerAccount = account;
                this.updateLedgerAccountTitle();
            });
        });

        this.addChildButton = MUIOutlet(this, 'add-child-btn', 'MUIButton');
        this.addChildButton.setAction(this, function(this:AnalyticAccountCell){
            if (this.delegate != null) this.delegate.addChildDidPress(this, this._account);
        });

        this.changeParentButton = MUIOutlet(this, 'change-parent-btn', 'MUIButton');
        this.changeParentButton.setAction(this, function(this:AnalyticAccountCell){
            if (this.delegate != null) this.delegate.changeParentDidPress(this, this._account);
        });
    }

    private _account:AnalyticAccount = null;
    set item(i:AnalyticAccount){
        this._account = i;
        this.titleTextField.text = i.title;
        this.conceptTextField.text = i.concept ?? null;
        this.requiredLinkSwitch.setOn(i.requiredLink == true);
        this.updateLedgerAccountTitle();
        this.titleTextField.layer.style.paddingLeft = ( i.indentLevel * 20 ) + "px";
    }

    private updateLedgerAccountTitle(){
        if (this.ledgerAccountDropdown == null) return;
        let acc = this._account?.ledgerAccount;
        this.ledgerAccountDropdown.title = acc != null ? ( acc.prefix + " " + acc.name ) : MIOLocalizeString("SELECT_LEDGER_ACCOUNT", "SELECT LEDGER ACCOUNT");
    }
}
